// action - state management
import { CHANGE_PASSWORD, ERROR, LOGIN, LOGOUT, REGISTER } from './actions';
import { InitialLoginContextProps } from 'types/auth';

// ==============================|| ACCOUNT REDUCER ||============================== //

interface AccountReducerActionProps {
    type: string;
    payload?: InitialLoginContextProps;
}

const initialState: InitialLoginContextProps = {
    isLoggedIn: false,
    isInitialized: false,
    isChangePassword: false,
    isError: false,
    user: null,
    errorMessage: null
};

const accountReducer = (state = initialState, action: AccountReducerActionProps) => {
    switch (action.type) {
        case REGISTER: {
            const { user } = action.payload!;
            return {
                ...state,
                user
            };
        }
        case LOGIN: {
            const { user } = action.payload!;
            return {
                ...state,
                isLoggedIn: true,
                isInitialized: true,
                user
            };
        }
        case CHANGE_PASSWORD: {
            const { user } = action.payload!;
            return {
                ...state,
                isLoggedIn: false,
                isInitialized: true,
                isChangePassword: true,
                user
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isInitialized: true,
                isLoggedIn: false,
                user: null
            };
        }
        case ERROR: {
            const { errorMessage } = action.payload!;
            return {
                ...state,
                isError: true,
                errorMessage
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
